import api from "../utils/api";
import { LOGOUT } from "../actions/types";

export const sourceList = ({ page = 0, size = 25, order = "name", direction = "ASC", raw = 1, search = "" } = {}) => async (dispatch) => {
    try {
        const url = `/areas/settings/p/${page}/s/${size}/o/${order}/${direction}/${raw}${search ? `/${search}` : ""}`;
        const res = await api.get(url);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const sourceGet = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.get(`/areas/settings/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const sourceSave = (payload) => async (dispatch) => {
    try {
        const res = await api.post(`/areas/settings`, payload);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const sourceDestroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.delete(`/areas/settings/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};
